<div class="row">
  <div class="col-12 mb-1">
    <app-client-autocomplete [(selectedClient)]="selectedClient"
      placeholder="{{'i18n.domain.export-configuration.field-value-replacements.client-selection-placeholder' | translate}}"></app-client-autocomplete>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <ejs-grid #clientGrid width="100%" rowHeight="38" [dataSource]="clientsHavingReplacements()"
      [allowSorting]="false" [allowPaging]="false" (rowSelected)="onGridClientSelected($event)" (actionComplete)="onActionComplete($event)">
      <e-columns>
        <e-column field="id" [visible]="false" [isPrimaryKey]="true"></e-column>
        <e-column field="name"
          headerText="{{'i18n.domain.export-configuration.configurations.overview.column-headers.client' | translate}}"
          clipMode="EllipsisWithTooltip">
          <ng-template #template let-data>
            {{data.name}} ({{data.customerNumber ?? data.vendorNumber}})
          </ng-template>
        </e-column>
      </e-columns>
    </ejs-grid>
  </div>
</div>
